<template>
<div class="not-logged-page">
    <v-toolbar flat>
        <v-list>
            <v-list-tile>
                <v-list-tile-title class="title">
                    <router-link :to="{ name: 'Login', params: {} }">Asko Pro</router-link>
                </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-toolbar>

    <router-view class="content"></router-view>

	<v-alert v-if="alerts.length > 0" :value="true" :type="alerts[0].success ? 'success' : 'error'">
		{{alerts[0].message}}
		<v-icon @click="deleteAlert(0)">check</v-icon>
	</v-alert>

	<v-alert v-if="alerts.length > 1" class="alert1" :value="true" :type="alerts[1].success ? 'success' : 'error'">
		{{alerts[1].message}}
		<v-icon @click="deleteAlert(1)">check</v-icon>
	</v-alert>

	<v-alert v-if="alerts.length > 2" class="alert2" :value="true" :type="alerts[2].success ? 'success' : 'error'">
		{{alerts[2].message}}
		<v-icon @click="deleteAlert(2)">check</v-icon>
	</v-alert>
</div>
</template>

<script>
import { CLEAN_ALERT } from '../variables'

export default {
	methods: {
		deleteAlert(value) {
			this.$store.dispatch(CLEAN_ALERT, value)
		}
	},
	computed: {
		alerts() {
			return this.$store.getters.alerts
		}
	}
}
</script>

<style lang="scss">
.not-logged-page {
    min-height: 100vh;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    .v-alert {
        bottom: 0;
        right: 0;
        position: fixed;

        &.alert1 {
            bottom: 70px;
        }

        &.alert2 {
            bottom: 140px;
        }
    }

    .content{
        height: 100%;
        width: 100%;
        margin: 20px;
    }

    .footer {
        background-color: white;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 0;
        width: 100%;

        .social-network {
            padding: 20px;
            img {
                height: 30px;
                width: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/defaultNotLogPage.vue